import script from "./TeacherInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeacherInfo.vue?vue&type=script&setup=true&lang=ts"

import "./TeacherInfo.vue?vue&type=style&index=0&id=73794a1e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73794a1e"]])

export default __exports__